// Ahri — Orb of Deception: fires a charm orb through the 3 closest enemies.
// Hits them on the way out AND on the return. The backmost enemy is charmed.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const CHARM_DURATION = 1;
const RETURN_DELAY_MS = 450;

export const ahriOrb: Ability = {
  id: "ahriOrb",
  displayName: "Orb of Deception",
  description:
    "Fires a charm orb through the 3 closest enemies for magic damage. Returns and hits them again — the backmost enemy is charmed.",
  iconId: "AhriQ",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 3)
      .map(e => e.pos);
  },

  computeHits({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 3);
    if (targets.length === 0) return [];

    const stats = effectiveStats(caster);
    const dmg = magicDamage(stats.ap * 0.9 + 48);
    const hits: AbilityHit[] = [];

    // Outbound: front → back
    for (const e of targets) {
      hits.push({ target: e, amount: dmg, type: "magical", suppressPopup: true, orbPass: "out" });
    }
    // Return: back → front; charm the backmost enemy (first hit on return)
    for (let i = targets.length - 1; i >= 0; i--) {
      const hit: AbilityHit = {
        target: targets[i], amount: dmg, type: "magical",
        suppressPopup: true, orbPass: "back", delayMs: RETURN_DELAY_MS,
      };
      // no effect on return hits
      hits.push(hit);
    }
    return hits;
  },
};
